// extracted by mini-css-extract-plugin
export default {"melodyVideo":"lQ-z","isFullWidth":"mQ-z","landingPageVideo":"nQ-z","play":"oQ-z","iframeVideo":"pQ-z","playHidden":"qQ-z","fullwidth":"rQ-z"};